export enum LiveChatBannerViewStatus {
  Available = 'available',
  Unavailable = 'unavailable',
}

type LiveChatEventsBaseArgs = {
  helpCenterSessionId: string | null
}

type LiveChatBannerViewedArgs = LiveChatEventsBaseArgs & {
  status: LiveChatBannerViewStatus
}

type LiveChatBannerViewedEventExtra = {
  live_chat_status: LiveChatBannerViewStatus
  help_center_session_id: string | null
}

export const liveChatBannerViewedEvent = (args: LiveChatBannerViewedArgs) => {
  const extra: LiveChatBannerViewedEventExtra = {
    live_chat_status: args.status,
    help_center_session_id: args.helpCenterSessionId,
  }

  return {
    event: 'user.live_chat_banner_viewed',
    extra,
  }
}

type LiveChatBannerClickedEventExtra = {
  help_center_session_id: string | null
}

export const liveChatBannerClickedEvent = (args: LiveChatEventsBaseArgs) => {
  const extra: LiveChatBannerClickedEventExtra = {
    help_center_session_id: args.helpCenterSessionId,
  }

  return {
    event: 'user.live_chat_banner_clicked',
    extra,
  }
}

type LiveChatFormSubmittedEventExtra = {
  help_center_session_id: string | null
}

export const liveChatFormSubmittedEvent = (args: LiveChatEventsBaseArgs) => {
  const extra: LiveChatFormSubmittedEventExtra = {
    help_center_session_id: args.helpCenterSessionId,
  }

  return {
    event: 'user.live_chat_form_submitted',
    extra,
  }
}

type LiveChatFormViewedEventExtra = {
  help_center_session_id: string | null
}

export const liveChatFormViewedEvent = (args: LiveChatEventsBaseArgs) => {
  const extra: LiveChatFormViewedEventExtra = {
    help_center_session_id: args.helpCenterSessionId,
  }

  return {
    event: 'user.live_chat_form_viewed',
    extra,
  }
}
